import React from 'react';
import { Link } from 'react-router-dom';
import OnVisible from 'react-on-visible';

//strip base-url for optimizing to relative-urls
const getRelativeUrl = (url) => {
    if (url === window.location.origin) {
        return '/';
    }
    return url.substr(window.location.origin.length);
};

const ReadMore = (props) => {
    const contentRight = () => {
        if (!!props.moreLeft) {
            return (
                <div className="col-xs-12 col-sm-6 col-md-6 no-padding">
                    <div
                        className={`readmore__inner-container ${
                            props.moreRight.readmore_image === false && 'empty'
                        } ${props.slug}`}>
                        {props.moreRight.readmore_image && (
                            <img
                                className="readmore__inner-container--image"
                                src={
                                    props.moreRight.readmore_image.sizes
                                        .img_related
                                }
                                alt="readmore"
                            />
                        )}
                        <h3 className="readmore__title">
                            {props.moreRight.readmore_title &&
                                props.moreRight.readmore_title}
                        </h3>
                        {!props.moreRight.readmore_link.url ? (
                            <Link
                                className="cta-btn white"
                                to={`${getRelativeUrl(
                                    props.moreRight.readmore_link
                                )}`}>
                                {props.moreRight.readmore_btntext
                                    ? props.moreRight.readmore_btntext
                                    : 'View more'}
                            </Link>
                        ) : (
                            <a
                                href={props.moreRight.readmore_link.url}
                                target="_blank"
                                className="cta-btn white">
                                {props.moreRight.readmore_btntext
                                    ? props.moreRight.readmore_btntext
                                    : 'View more'}
                            </a>
                        )}
                    </div>
                </div>
            );
        }
    };

    const contentLeft = () => {
        if (!!props.moreLeft) {
            return (
                <div
                    className={`readmore__inner-container ${
                        props.moreLeft.readmore_image === false && 'empty'
                    }`}>
                    {props.moreLeft.readmore_image && (
                        <img
                            className="readmore__inner-container--image"
                            src={
                                props.moreLeft.readmore_image.sizes.img_related
                            }
                            alt="readmore"
                        />
                    )}
                    <h3
                        className={`readmore__title ${
                            props.moreLeft.readmore_image === false && 'empty'
                        }`}>
                        {props.moreLeft.readmore_title &&
                            props.moreLeft.readmore_title}
                    </h3>
                    {!props.moreRight.readmore_link.url &&
                    props.router !== '/people' ? (
                        <Link
                            className={`${
                                props.moreLeft.readmore_image === false
                                    ? 'cta-btn black empty'
                                    : 'cta-btn black'
                            }`}
                            to={
                                props.moreLeft.readmore_link &&
                                `${getRelativeUrl(
                                    props.moreLeft.readmore_link
                                )}`
                            }>
                            {props.moreLeft.readmore_btntext
                                ? props.moreLeft.readmore_btntext
                                : 'View more'}
                        </Link>
                    ) : (
                        <a
                            href={
                                !props.router
                                    ? props.moreLeft.readmore_link.url
                                    : 'mailto:jobs@friendsagency.com'
                            }
                            target="_blank"
                            className="cta-btn white">
                            {props.moreLeft.readmore_btntext
                                ? props.moreLeft.readmore_btntext
                                : 'View more'}
                        </a>
                    )}
                </div>
            );
        }
    };

    return (
        <div className="overflow-container">
            <OnVisible className="not-appeared">
                <div className="readmore content-container">
                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-6 no-padding">
                            {contentLeft()}
                        </div>
                        {contentRight()}
                    </div>
                </div>
            </OnVisible>
        </div>
    );
};

export default ReadMore;



// WEBPACK FOOTER //
// ./src/components/Pages/ReadMore.jsx